<template>
  <div id="actionList">
    <div class="action">
      <div id="actionLog">...</div>
      <div class="box">
        <div class="buttonbox">
          <button v-on:click="changeToAction('watch')" type="button" v-bind:class="{ active:selected === 'watch'} " class="btn">{{watchTranslate}}</button>
          <button v-on:click="changeToAction('take')" type="button" v-bind:class="{ active:selected === 'take'} " class="btn">{{takeTranslate}}</button>
          <button v-on:click="changeToAction('talk')" type="button" v-bind:class="{ active:selected === 'talk'} " class="btn">{{talkTranslate}}</button>
        </div>
        <div class="itembox">
          <InventarList></InventarList>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import InventarList from '@/components/InventarList'
import { mapGetters } from 'vuex'
import { interAction } from '@/store/util/naming'
export default {
  name: 'actionList',
  components: {
    InventarList
  },
  data() {
    return {
      selected: interAction.watch,
      watchTranslate:"Schauen",
      takeTranslate:"Nehmen",
      talkTranslate:"Reden",
    }
  },
  computed: {
    ...mapGetters({
      activeAction: 'getAction'
    })
  },
  methods: {
    changeToAction(value) {
      this.$store.commit('setAction', value)
      switch (value) {
        case interAction.watch:{
            this.selected = interAction.watch
        }
        break;
        case interAction.take:{
            this.selected = interAction.take
        }
        break;
        case interAction.talk:{
            this.selected = interAction.talk
        }
        break;
        default:
      }

    }
  },
}
</script>
<style lang="scss" scoped>
.action {
    border-bottom: solid 5px red;

    #actionLog {
        border-bottom: solid 5px red;
        position: relative;
        width: 100%;
        text-align: center;
        height: 5rem;
        line-height: 2rem;
        font-size: 0.9rem;
    }
    .box {
        display: flex;
        min-height: 150px;
        .itembox {
            flex: 1;
            border-left: solid 5px red !important;
        }
        .buttonbox {
            width: 50%;
            flex: 1;
            padding-top: 5px;
            button {
                cursor: pointer;
                width: 205px;
                font-size: 25px;
                background: none;
                margin-left: 5px;
                padding: 8px;
                border: none;
            }
            *:focus {
                outline: none;
            }
            .active {
                border: solid 5px red !important;
                box-shadow: 2px 2px white;
            }
        }
    }



}
</style>
